/**
 * Stasher.news nav scheme (verified from live site CSS):
 * Chakra Petch, uppercase, weight 400, letter-spacing .05em, and a
 * brightness-only active state (no bold, no underline) on the ramp
 * 0.55 -> 0.75 (hover) -> 0.9 (active) opacity.
 */
export const NAV_LINK_BASE =
  'font-normal uppercase tracking-[0.05em] text-[13px] text-[rgba(0,0,0,0.55)] dark:text-[rgba(255,255,255,0.55)] hover:text-[rgba(0,0,0,0.75)] dark:hover:text-[rgba(255,255,255,0.75)]';

export const NAV_LINK_ACTIVE =
  'text-[rgba(0,0,0,0.9)] dark:text-[rgba(255,255,255,0.9)]';

/**
 * Complete active-state string — use via ternary, NOT cn() merge:
 * tailwind-merge cannot dedupe conflicting arbitrary rgba() text colors
 * (it can't infer intent), so merged classes both land on the element
 * and stylesheet order decides — nondeterministic.
 */
export const NAV_LINK_ACTIVE_FULL =
  'font-normal uppercase tracking-[0.05em] text-[13px] text-[rgba(0,0,0,0.9)] dark:text-[rgba(255,255,255,0.9)]';

/** Compact ticker/nav size variant of NAV_LINK_BASE (12px). */
export const NAV_LINK_BASE_COMPACT =
  'font-normal uppercase tracking-[0.05em] text-[12px] text-[rgba(0,0,0,0.55)] dark:text-[rgba(255,255,255,0.55)] hover:text-[rgba(0,0,0,0.75)] dark:hover:text-[rgba(255,255,255,0.75)]';
